import styled from 'styled-components';

import { Form } from '@tillersystems/stardust';

export const SearchForm = styled(Form)`
  width: auto;
`;
